/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const RESET_REDUX_DL = 'RESET_REDUX_DL';
export const SEARCH_TAB_DATA_DL = 'SEARCH_TAB_DATA_DL';
export const HANDLE_ERROR_MESSAGE_FOR_DL = 'HANDLE_ERROR_MESSAGE_FOR_DL';
export const GET_PLAN_TYPE_DATA_DL = 'GET_PLAN_TYPE_DATA_DL';
export const GET_MANUFACTURER_DATA_DL = 'GET_MANUFACTURER_DATA_DL';
export const MFG_SELECTED_DL = 'MFG_SELECTED_DL';
export const TEMPLATE_TYPE_LIST_DL = 'TEMPLATE_TYPE_LIST_DL';
export const TEMPLATE_NAME_LIST_DL = 'TEMPLATE_NAME_LIST_DL';
export const TEMP_LETTER_TABLE_DATA = 'TEMP_LETTER_TABLE_DATA';
export const SAVE_CREATE_LETTER_DATA_DISPLAY =
  'SAVE_CREATE_LETTER_DATA_DISPLAY';
export const FETCH_CREATE_LETTER_DETAIL_DISPLAY =
  'FETCH_CREATE_LETTER_DETAIL_DISPLAY';
export const FETCH_CREATE_LETTER_DETAIL_DATA_DISPLAY =
  'FETCH_CREATE_LETTER_DETAIL_DATA_DISPLAY';
export const GET_INVOICE_DETAILS_BY_INVOICE_NUM_DISPLAY =
  'GET_INVOICE_DETAILS_BY_INVOICE_NUM_DISPLAY';
export const GET_DISPLAY_TEMPLATE_EXTRA_STATE =
  'GET_DISPLAY_TEMPLATE_EXTRA_STATE';
export const GET_PRINT_PREVIEW_DISPLAY = 'GET_PRINT_PREVIEW_DISPLAY';
export const GET_PREVIEW_DRAFT_PDF_DISPLAY = 'GET_PREVIEW_DRAFT_PDF_DISPLAY';

export const GET_TO_MAIL_ID_DISPLAY = 'GET_TO_MAIL_ID_DISPLAY';
export const GET_FROM_MAIL_ID_DISPLAY = 'GET_FROM_MAIL_ID_DISPLAY';
export const HANDLE_FIRST_ERROR = 'HANDLE_FIRST_ERROR';
export const SEND_LETTER_BY_EMAIL_DISPLAY = 'SEND_LETTER_BY_EMAIL_DISPLAY';
export const DISPLAY_LETTER_CLEAR_REDUX_DATA =
  'DISPLAY_LETTER_CLEAR_REDUX_DATA';
